import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';

type BodyResponse = {
  Body: string;
};

export function fillTemplate({ url: { service: baseURL }, token }: IAPI) {
  return async function find(body: {
    LoanApplicationID: string;
    LoanQuoteID: string;
    Body: string;
  }): Promise<BodyResponse> {
    return send({
      baseURL,
      token,
      path: `/communication-template`,
      method: 'POST',
      body,
    });
  };
}
